import axios from 'axios';
import getConfig from 'next/config';
import { getCookie } from '~utils/cookie-operation';

const instance = axios.create({
  baseURL: getCookie('FILE_SVC_URL'),
  timeout: 100000,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
const dataURItoBlob = (dataURI: any) => {
  var mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]; // mime类型
  var byteString = atob(dataURI.split(',')[1]); //base64 解码
  var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
  var intArray = new Uint8Array(arrayBuffer); //创建视图

  for (var i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([intArray], { type: mimeString });
};

export { instance as axiosInstanceFileService, dataURItoBlob };

export const uploadFile = (url: string, params: any) => {
  return instance.post(url, params);
};

export default uploadFile;
